var mensBlazers = {
  category: "Men's",
  product: "Blazers",
  sections: [{
      section: {
        title: "Size Chart",
        type: "table",
        header: [
          "Blazer Chest Size",
          "",
          "Your Chest",
          "Your Natural Waist",
          "Your Arm (Spine To Wrist)",
        ],
        rows: [
          ["36",  "","35 - 36", "28 - 29", "32 - 32.75"],
          ["38",  "","37 - 38", "30 - 31", "32.75 - 33.5"],
          ["40",  "","39 - 40", "32 - 33", "33.5 - 34.25"],
          ["42",  "","41 - 42", "34 - 35", "34.25 - 35"],
          ["44",  "","43 - 44", "36 - 37", "35 - 35.75"],
          ["46",  "","45 - 46", "38 - 39", "35.75 - 36.5"],
          ["48",  "","47 - 48", "40 - 41", "36.5 - 37.25"]
        ]
      }
    },
    {
      section: {
        title: "Fit Guidance",
        type: "twoCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_Blazer_-_Classic_Fit.png?14280",
            title: "Classic:",
            body: "A tapered silhouette and accommodating fit, with room for movement in the chest, arms, and waist."
          }],
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_Blazer_-_Slim_Fit.png?14280",
            title: "Slim:",
            body: "A tapered silhouette with a more contemporary fit, slimmer throughout the chest, arms, and waist than our Classic Fit."
          }]
        ]
      }
    },
    {
      section: {
        title: "Length Guidance",
        type: "twoCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_Blazer_-_Short_Length.png?14277",
            title: "Short:",
            body: "1.5” (3.8 cm) shorter in the body and sleeve than our Regular Length."
          }],
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_Blazer_-_Regular_Length.png?14277",
            title: "Regular:",
            body: "Our standard length, with the hem hitting at the hips."
          }],
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_Blazer_-_Long_Length.png?14277",
            title: "Long:",
            body: "1.5” (3.8 cm) longer in the body and sleeve than our Regular Length."
          }]
        ]
      }
    },
    {
      section: {
        title: 'How to Measure',
        type: "singleCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Mens_-_How_To_Measure.png?14026"
          }],
          [{
            title: "Neck: ",
            body: "Wrap the measuring tape loosely around the base of your neck, keeping one finger between your neck and the tape."
          }],
          [{
            title: "Arm (Spine to Wrist): ",
            body: "The arm measurement used for sleeve length is measured from the center back of the neck to wrist. Hold your arm out to the side with your elbow slightly bent, and measure from the back center of your neck (your spine) down the outside of your arm to your wrist bone."
          }],
          [{
            title: "Chest: ",
            body: "Wrap the measuring tape around the circumference of your chest at the widest point, approximately 1\"/2.5 cm below your armpit. Inhale, exhale, and then place a finger behind the tape. Keep the tape level and snug, but not too tight."
          }],
          [{
            title: "Natural Waist: ",
            body: "Bend to the side to find the natural crease of your waist. Wrap the measuring tape at this point, keeping the tape slightly loose."
          }],
          [{
            title: "Waist: ",
            body: "Wrap the measuring tape around your waistline (where you want your pants to sit), keeping the tape slightly loose. Bluffworks pants are offered in 1\"/2.5 cm increments, so we suggest sizing up if you're between sizes."
          }],
          [{
            title: "Hips: ",
            body: "Keep feet together, and wrap the measuring tape around the fullest part of your seat (approximately 8\"/20.3 cm below your natural waist), keeping the tape slightly loose."
          }],
          [{
            title: "Thigh: ",
            body: "Wrap the measuring tape around the fullest part of the thigh (approximately 1\"/2.5 cm below the crotch), keeping the tape slightly loose."
          }]
        ]
      }
    }
  ]
};